import styled from "@emotion/styled";
import { default as NextImage } from "next/image";

const LazyImageStyled = styled.div<{ hasBorder: boolean; paddingTop: string }>`
  position: relative;
  box-sizing: border-box;
  height: 0;
  padding-top: ${({ paddingTop }) => paddingTop};
  ${({ hasBorder, theme }) =>
    hasBorder && `border: 1px solid ${theme.colors.tone.anthraciteDark}`}
`;

const LazyImageImg = styled(NextImage)`
  position: absolute;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export { LazyImageStyled, LazyImageImg };
